import { z } from 'zod';

/**
 * 管理員建立客戶端用戶 — 與後端 `user.dto.ts` 的 CreateUserDTO 對齊。
 * 後續若導入 nestjs-zod / OpenAPI codegen，這份會由後端產出，前端改為 import。
 */

const passwordRule = z
  .string()
  .min(8, '密碼至少 8 個字元')
  .max(64, '密碼不可超過 64 個字元')
  .regex(/[A-Z]/, '密碼需含大寫英文字母')
  .regex(/[a-z]/, '密碼需含小寫英文字母')
  .regex(/[0-9]/, '密碼需含數字');

export const UserCreateSchema = z
  .object({
    username: z
      .string()
      .min(4, '帳號至少 4 個字元')
      .max(20, '帳號不可超過 20 個字元')
      .regex(
        /^[A-Za-z1-9][A-Za-z0-9]*$/,
        '帳號僅限英數，首位不可為 0'
      ),
    password: passwordRule,
    confirmPassword: z.string().min(1, '請再次輸入密碼'),
    tierId: z.number({ message: '請選擇等級' }).int().positive('請選擇等級'),
    // 去品牌化 M4：寫入必須顯式指定目標品牌，不沿用「檢視範圍」。
    targetBrand: z
      .string({ message: '請選擇目標品牌' })
      .regex(/^[a-z][a-z0-9_]{1,15}$/, '請選擇目標品牌'),
  })
  .refine((v) => v.password === v.confirmPassword, {
    message: '兩次密碼不一致',
    path: ['confirmPassword'],
  });

export type UserCreateDTO = z.infer<typeof UserCreateSchema>;

/** 管理員重設用戶密碼 */
export const UserResetPasswordSchema = z
  .object({
    password: passwordRule,
    confirmPassword: z.string().min(1, '請再次輸入密碼'),
  })
  .refine((v) => v.password === v.confirmPassword, {
    message: '兩次密碼不一致',
    path: ['confirmPassword'],
  });

export type UserResetPasswordDTO = z.infer<typeof UserResetPasswordSchema>;

/** BO linked-member email edit — matches the dedicated admin route contract. */
export const UserEmailUpdateSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email('請輸入有效的 Email')
    .max(254, 'Email 不可超過 254 個字元'),
});

export type UserEmailUpdateDTO = z.infer<typeof UserEmailUpdateSchema>;

/** 批量指派等級 */
export const BatchAssignTierSchema = z.object({
  tierId: z.number({ message: '請選擇等級' }).int().positive('請選擇等級'),
});

export type BatchAssignTierDTO = z.infer<typeof BatchAssignTierSchema>;
